import { resolveMediaUrl } from '../../../utils/mediaUrl';

const WhatWeDoRowEditor = ({
  item,
  index,
  values,
  onChange,
  onImageUpload,
  onIconUpload,
  isUploadingImage = false,
  isUploadingIcon = false,
}) => (
  <article className="rounded-md border border-[#e4d9c8] bg-[#faf8f4] p-4">
    <div className="mb-4 border-b border-[#e4d9c8] pb-3">
      <p className="text-[11px] font-medium uppercase tracking-[0.14em] text-[#6b635c]">
        Row {index}
      </p>
      <p className="mt-1 text-sm font-semibold text-[#130705]">
        {values.title || item.altText || 'Service row'}
      </p>
      {values.linkUrl ? (
        <p className="mt-0.5 truncate text-[11px] text-[#a8a098]">{values.linkUrl}</p>
      ) : null}
    </div>

    <div className="mb-4 grid gap-4 lg:grid-cols-2">
      <div>
        <p className="mb-2 text-[12px] font-medium text-[#6b635c]">Row image</p>
        <div className="overflow-hidden rounded-md border border-[#e4d9c8] bg-white">
          <img
            src={resolveMediaUrl(item.url)}
            alt={item.altText || ''}
            className="h-32 w-full object-cover"
          />
        </div>
        <label
          className={`mt-2 inline-flex cursor-pointer rounded-md border border-[#e4d9c8] bg-white px-3 py-1.5 text-[12px] font-medium text-[#130705] hover:bg-[#faf8f4] ${
            isUploadingImage ? 'pointer-events-none opacity-60' : ''
          }`}
        >
          {isUploadingImage ? 'Uploading…' : 'Change image'}
          <input
            type="file"
            accept="image/*"
            className="hidden"
            disabled={isUploadingImage}
            onChange={onImageUpload}
          />
        </label>
      </div>

      <div>
        <p className="mb-2 text-[12px] font-medium text-[#6b635c]">Row icon</p>
        <div className="flex h-32 items-center justify-center rounded-md border border-[#e4d9c8] bg-white">
          {item.thumbnailUrl ? (
            <img
              src={resolveMediaUrl(item.thumbnailUrl)}
              alt=""
              className="h-10 w-10 object-contain"
            />
          ) : null}
        </div>
        <label
          className={`mt-2 inline-flex cursor-pointer rounded-md border border-[#e4d9c8] bg-white px-3 py-1.5 text-[12px] font-medium text-[#130705] hover:bg-[#faf8f4] ${
            isUploadingIcon ? 'pointer-events-none opacity-60' : ''
          }`}
        >
          {isUploadingIcon ? 'Uploading…' : 'Change icon'}
          <input
            type="file"
            accept="image/*,.svg,.ico"
            className="hidden"
            disabled={isUploadingIcon}
            onChange={onIconUpload}
          />
        </label>
      </div>
    </div>

    <div className="grid gap-3">
      <div>
        <label className="mb-1.5 block text-[12px] font-medium text-[#6b635c]">Title</label>
        <input
          type="text"
          value={values.title || ''}
          onChange={(event) => onChange({ ...values, title: event.target.value })}
          className="w-full rounded-md border border-[#d8cfc0] bg-white px-3 py-2 text-sm outline-none focus:border-[#785E32]"
        />
      </div>
      <div>
        <label className="mb-1.5 block text-[12px] font-medium text-[#6b635c]">Description</label>
        <textarea
          value={values.description || ''}
          onChange={(event) => onChange({ ...values, description: event.target.value })}
          rows={3}
          className="w-full rounded-md border border-[#d8cfc0] bg-white px-3 py-2 text-sm outline-none focus:border-[#785E32]"
        />
      </div>
      <label className="flex items-center gap-2 text-[13px] text-[#4a4340]">
        <input
          type="checkbox"
          checked={Boolean(values.reverse)}
          onChange={(event) => onChange({ ...values, reverse: event.target.checked })}
          className="h-4 w-4 rounded border-[#d8cfc0]"
        />
        Reverse layout (image on the right)
      </label>
    </div>
  </article>
);

export default WhatWeDoRowEditor;
